import {gsap} from "gsap";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

let workSection = document.querySelector('.home-work');

if( workSection ) {
    ScrollTrigger.create({
        trigger: ".home-work h2",
        start: "top top",
        end: "top 230",
        endTrigger: ".home-work a.btn",
        pin: true,
        pinSpacing: false,
        // markers: true,
        scrub: false,
    });
}